import useSWR from "swr";
import { useRecoilValue } from "recoil";
import { kuchikomyuDateRangeState } from "../../store/kuchikomyuDateRangeState";

type SurveyScores = {
  survey_answer_scores_count: number;
  survey_answer_scores_average: number;
  survey_answer_scores_1_count: number;
  survey_answer_scores_2_count: number;
  survey_answer_scores_3_count: number;
  survey_answer_scores_4_count: number;
  survey_answer_scores_5_count: number;
  survey_answer_scores_1_percentage: number;
  survey_answer_scores_2_percentage: number;
  survey_answer_scores_3_percentage: number;
  survey_answer_scores_4_percentage: number;
  survey_answer_scores_5_percentage: number;
  id: string;
  title: string;
}[];


export const useFetchKuchikomyuSurveyScores = (restaurantId: string) => {
  const dateRange = useRecoilValue(kuchikomyuDateRangeState)
  const { data: kuchikomyuSurveyScores, error, isLoading } = useSWR<SurveyScores>(`kuchikomyu/survey/scores/?restaurantId=${restaurantId}&startDate=${dateRange.startDate}&endDate=${dateRange.endDate}`)
  return { kuchikomyuSurveyScores, isLoading, error };
};